export const DateTransformer = (val) => {
    if (typeof val !== 'string') {
        return val;
    }
    const date = new Date(val);
    if (isNaN(date.getTime())) {
        return val;
    }
    return date;
};
